import React, { Component } from 'react';
import ThankYou from './ThankYouFR';

import data from '../data/dataFR.json';

class ContactFR extends Component {
  state = {
    company: data.company,
    contact: data.contact,
  };
  render() {
    return (
      <div>
        <div className="business-banner">
          <div className="hvrbox">
            <img src="/images/_bg/02.jpg" alt="Contact Form" className="hvrbox-layer_bottom" />
            <div className="hvrbox-layer_top">
              <div className="container">
                <div className="overlay-text text-left">
                  <h3>{this.state.contact.title}</h3>
                  <nav aria-label="breadcrumb">
                    <ol className="breadcrumb">
                      <li className="breadcrumb-item">
                        <a href="/">Home</a>
                      </li>
                      <li className="breadcrumb-item active" aria-current="page">
                        {this.state.contact.title}
                      </li>
                    </ol>
                  </nav>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="padding-top-large" style={{ backgroundColor: '#eee' }} />
        <div className="bussiness-our-address" style={{ backgroundColor: '#eee' }}>
          <div className="container">
            <div className="row">
              <div className="col-md-4">
                <div className="single-address text-center">
                  <i className="fa fa-map-marker" />
                  <h4>{this.state.contact.address}</h4>
                  <p>
                    {this.state.company.net.address.street}
                    <br />
                    {this.state.company.net.address.city} / {this.state.company.net.address.county}
                    <br />
                    {this.state.company.net.address.country} / {this.state.company.net.address.continent}
                  </p>
                </div>
              </div>
              <div className="col-md-4">
                <div className="single-address text-center">
                  <i className="fa fa-phone" />
                  <h4>{this.state.contact.call}</h4>
                  <p>
                    Editorial:{' '}
                    <a href={`tel:${this.state.company.net.phone.editorial}`}>
                      {this.state.company.net.phone.editorial}
                    </a>{' '}
                    <br />
                    Marketing:{' '}
                    <a href={`tel:${this.state.company.net.phone.marketing}`}>
                      {this.state.company.net.phone.marketing}
                    </a>{' '}
                  </p>
                </div>
              </div>
              <div className="col-md-4">
                <div className="single-address text-center">
                  <i className="fa fa-location-arrow" />
                  <h4>{this.state.contact.email}</h4>
                  <p>
                    Editorial:{' '}
                    <a href={`mailto:${this.state.company.net.email.editorial}`}>
                      {this.state.company.net.email.editorial}
                    </a>
                    <br />
                    Marketing:{' '}
                    <a href={`mailto:${this.state.company.net.email.marketing}`}>
                      {this.state.company.net.email.marketing}
                    </a>
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="padding-top-large" />
        {document.referrer === 'https://formspree.io/info@multimediacongo.com' ? (
          <ThankYou />
        ) : (
          <form action="https://formspree.io/info@multimediacongo.com" method="POST">
            <input type="hidden" name="_next" value="https://www.multimediacongo.com" />
            <input type="hidden" name="_subject" value="Multimediacongo.com - 📧 📧 📧 - New message from our site!" />
            <div className="bussiness-contact-form">
              <div className="container">
                <div className="row">
                  <div className="col-md-12">
                    <div className="business-title-left">
                      <h2>{this.state.contact.contactForm}</h2>
                      <span className="title-border-left" />
                      <p>
                        {this.state.contact.desc1}
                        <br />
                        {this.state.contact.desc2}
                      </p>
                    </div>
                  </div>

                  <div className="col-md-6">
                    <div className="form-group">
                      <input
                        type="text"
                        name="firstname"
                        className="form-control"
                        id="formGroupExampleInput1"
                        placeholder={this.state.contact.firstName}
                      />
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className="form-group">
                      <input
                        type="text"
                        name="lastname"
                        className="form-control"
                        id="formGroupExampleInput2"
                        placeholder={this.state.contact.lastName}
                      />
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className="form-group">
                      <input
                        type="email"
                        name="email"
                        className="form-control"
                        id="formGroupExampleInput3"
                        placeholder={this.state.contact.yourEmail}
                      />
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className="form-group">
                      <input
                        type="number"
                        name="phone"
                        className="form-control"
                        id="formGroupExampleInput4"
                        placeholder={this.state.contact.yourPhone}
                      />
                    </div>
                  </div>
                  <div className="col-md-12">
                    <div className="form-group">
                      <textarea
                        className="form-control"
                        id="exampleFormControlTextarea15"
                        rows="3"
                        name="message"
                        placeholder={this.state.contact.yourMessage}
                      />
                    </div>
                  </div>
                  <div className="col-md-12">
                    <div className="form-group">
                      <input
                        className="btn bussiness-btn-larg"
                        type="submit"
                        value={this.state.contact.sendMessage}
                        style={{ color: 'white' }}
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </form>
        )}
        <div className="padding-top-large" />
      </div>
    );
  }
}

export default ContactFR;



// WEBPACK FOOTER //
// ./src/components/ContactFR.js